const RED = "#EA483E";

const COLORS = {
  primary: {
    active: "#413D7D",
    inActive: "#D5D5E0",
    background: "#FAFAFA",
  },
  error: {
    active: RED,
    inActive: "#F9C8C5",
    background: "#FFFAFA",
  },
  black: {
    "100%": "#0D0D0D",
    "80%": "#3D3D3D",
    "60%": "#666666",
    "40%": "#A6A6A6",
    "20%": "#D2D2D2",
    blur: "rgba(0, 0, 0, 0.70)",
  },
  white: {
    "100%": "#fff",
    "60%": "#F5F5F5",
  },
  red: RED,
};

export default COLORS;
